/* eslint-disable import-x/no-default-export */
// TODO: remove if unused
// import type { GetRecommendations } from '../../queries/@types/GetRecommendations';
// const getRecommendations: GetRecommendations = {
const getRecommendations: any = {
  viewer: {
    firstName: 'Candidate',
    recommendations: {
      recommendedJobs: {
        jobs: [
          {
            advertiser: 'Workforce Partners Recruitment Pty. Ltd',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'A storeman/Labourer with general warehousing/factory experience and good communication to deal with customers, casual to permanent, Blacktown area.',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Blacktown',
            id: '41354827',
            listed: '2d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Blacktown',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41354827',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Storeman/Labourer - Ongoing Casual to Permanent',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Wynstan – Blinds Doors Shutters Awnings',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'We’re on the hunt for reliable, hands-on and enthusiastic applicants to join our fast-paced manufacturing factory. Enquire within!',
            enhancements: {
              bullets: [
                'Fantastic manufacturing facility in Yennora',
                'Family orientated environment, great team to work with',
                'Parking available onsite & Immediate start',
              ],
              logo: 'http://www.seek.com.au/logos/Jobseeker/Thumbnail/767820',
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Yennora',
            id: '41326938',
            listed: '10d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Yennora',
              __typename: 'JobLocation',
            },
            salaryText: '$25 - $29.99 per hour',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41326938',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Warehouse Dispatch',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Cornerstone HR',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Immediate start | Ongoing opportunity | Erskine Park Location',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Erskine Park',
            id: '41348122',
            listed: '3d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Erskine Park',
              __typename: 'JobLocation',
            },
            salaryText: '$26 - $27 p.h. + overtime',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41348122',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Pick Packer',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'B&J City Kitchen Pty Ltd',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              "At Beak & Johnston, we're looking to recruit a number of Store Persons / Forklift Operators at our City Kitchen site in Arndell Park.",
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Arndell Park',
            id: '41326997',
            listed: '10d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Arndell Park',
              __typename: 'JobLocation',
            },
            salaryText: '$27.11 per hour',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41326997',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Store Person / Forklift Operator (Multiple Vacancies)',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Private Advertiser',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Soap Solutions is currently seeking a Warehouse Assistant/Forklift Driver to; control/manage the flow of stock through their warehouse, monitor goods',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Warriewood',
            id: '41359453',
            listed: '1d ago',
            location: {
              name: 'Sydney',
              area: 'North Shore & Northern Beaches',
              suburb: 'Warriewood',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41359453',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Warehouse Assistant/Forklift Driver',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Private Advertiser',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Growing company looking to add additional LO Forklift Drivers to our already successful team',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney',
            id: '41321963',
            listed: '11d ago',
            location: {
              name: 'Sydney',
              area: 'CBD, Inner West & Eastern Suburbs',
              suburb: 'Sydney',
              __typename: 'JobLocation',
            },
            salaryText: '$25 - $34.99 per hour',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41321963',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Forklift Driver (LO)',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Chandler Macleod Group',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Experienced high reach forklift driver\r\nSolid stores / warehousing back ground\r\nMust be computer savvy ',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney, South West & M5 Corridor',
            id: '41335366',
            listed: '8d ago',
            location: {
              name: 'Sydney',
              area: 'South West & M5 Corridor',
              suburb: null,
              __typename: 'JobLocation',
            },
            salaryText: '$34 - $35 p.h.',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41335366',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Experienced HR Forklift driver with stores experience',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Action Workforce',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'We are looking for experienced High Reach operators that are experienced with inventory and customer service processes.',
            enhancements: {
              bullets: [
                'Work for Leading Company',
                'Monday to Friday - day shifts',
                'High reach operation and inventory',
              ],
              logo: 'http://www.seek.com.au/logos/Jobseeker/Thumbnail/664427',
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney',
            id: '41358244',
            listed: '1d ago',
            location: {
              name: 'Sydney',
              area: 'CBD, Inner West & Eastern Suburbs',
              suburb: 'Sydney',
              __typename: 'JobLocation',
            },
            salaryText: '$29.00 - $33.00 p.h.',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41358244',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'High Reach Forklift storeman Required!',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'DGL Logistics Pty Ltd',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'DGL is seeking a full-time professional driver to operate our heavy rigid vehicle.',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Smithfield',
            id: '41317163',
            listed: '14d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Smithfield',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41317163',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'HR Driver',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Complete Recruitment Solutions P/L',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              "Start NOW! Working in a 'State of the art' warehouse. Day shift. Great team environment, highreach & wave rider machines.",
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney, Parramatta & Western Suburbs',
            id: '41356927',
            listed: '1d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: null,
              __typename: 'JobLocation',
            },
            salaryText: '$27.72  + Super + Overtime',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41356927',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Forklift Driver - Store Person',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'B&J City Kitchen Pty Ltd',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Do you have extensive experience as a Supervisor in a Warehouse (Inbound) environment? Looking for a new challenge?',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Arndell Park',
            id: '41348631',
            listed: '3d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Arndell Park',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41348631',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Team Leader: Warehouse Recievals',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Lidco NSW Pty Ltd',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'A rapidly growing business is looking to employee 2 x Drivers/Warehouse staff. ',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Wentworth Point',
            id: '41347566',
            listed: '3d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Wentworth Point',
              __typename: 'JobLocation',
            },
            salaryText: '$26per hour + Site Allowance',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41347566',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Truck Driver/Warehouse Operator',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'AWX Sydney',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'AWX are currently recruiting for a Storesman with steel manufacturing experience. ',
            enhancements: {
              bullets: [
                'Steel manufacturing experience required',
                'Ongoing work available for the right candidate',
                'Must have experience with power tools',
              ],
              logo: 'http://www.seek.com.au/logos/Jobseeker/Thumbnail/522965',
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Eastern Creek',
            id: '41359790',
            listed: '1d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: 'Eastern Creek',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41359790',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Storeman',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Private Advertiser',
            classification: 'Sales',
            description:
              'We Career Education Consultancy Australia an Education and Migration company located in Sydney CBD.',
            enhancements: {
              bullets: ['Sales', 'Public Relations', 'Consulting'],
              logo: 'http://www.seek.com.au/logos/Jobseeker/Thumbnail/444790',
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney',
            id: '41306919',
            listed: '16d ago',
            location: {
              name: 'Sydney',
              area: 'CBD, Inner West & Eastern Suburbs',
              suburb: 'Sydney',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41306919',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'New Business Development',
            title: 'Business Development Manager',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'AWX Sydney',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'AWX are currently looking for an experienced Line Leader to work within a packaging environment.  ',
            enhancements: {
              bullets: [
                'Temp to Perm Opportunity ',
                'Great company',
                'Immediate Start',
              ],
              logo: 'http://www.seek.com.au/logos/Jobseeker/Thumbnail/522965',
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney, Parramatta & Western Suburbs',
            id: '41358559',
            listed: '1d ago',
            location: {
              name: 'Sydney',
              area: 'Parramatta & Western Suburbs',
              suburb: null,
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41358559',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'Line Leader',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Everlast Tarping Systems Pty Ltd',
            classification: 'Sales',
            description:
              'We are looking for a new detail orientated, customer service based team member to join our company',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Narellan',
            id: '41342523',
            listed: '4d ago',
            location: {
              name: 'Sydney',
              area: 'South West & M5 Corridor',
              suburb: 'Narellan',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41342523',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Sales Representatives/Consultants',
            title: 'Internal Sales',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Labourforce',
            classification: 'Manufacturing, Transport & Logistics',
            description:
              'Labourforce are currently seeking an LO licensed Order Picker for a warehouse distribution centre in Marsden park!',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Marsden Park',
            id: '41306450',
            listed: '16d ago',
            location: {
              name: 'Sydney',
              area: 'North West & Hills District',
              suburb: 'Marsden Park',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41306450',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Warehousing, Storage & Distribution',
            title: 'LO ORDER PICKER OPERATORS / AFTERNOON SHIFT',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Private Advertiser',
            classification: 'Sales',
            description:
              'A great opportunity to join to join an entrepreneurial and rapidly expanding technology company in ANZ.',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney',
            id: '41319352',
            listed: '11d ago',
            location: {
              name: 'Sydney',
              area: 'CBD, Inner West & Eastern Suburbs',
              suburb: 'Sydney',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41319352',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'New Business Development',
            title: 'Business Development Manager',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Natural Solar',
            classification: 'Sales',
            description:
              'Renewable Solar & Energy Storage Sales Consultant. Due to Government Programs & Subsidies we have an abundance of warm inbound lead opportunities.',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Chatswood',
            id: '41353303',
            listed: '2d ago',
            location: {
              name: 'Sydney',
              area: 'North Shore & Northern Beaches',
              suburb: 'Chatswood',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41353303',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Sales Representatives/Consultants',
            title:
              'Sales Consultant - Willing to be part of an amazing culture!',
            __typename: 'RecommendedJob',
          },
          {
            advertiser: 'Big Life Journey - Jo Farrugia',
            classification: 'Sales',
            description:
              'Seeking self-starters looking to work in the personal development industry. \nYou will enjoy a portable business that you can work from home. \n',
            enhancements: {
              bullets: [],
              logo: null,
              __typename: 'JobEnhancements',
            },
            flattenedLocation: 'Sydney',
            id: '41356665',
            listed: '2d ago',
            location: {
              name: 'Sydney',
              area: 'CBD, Inner West & Eastern Suburbs',
              suburb: 'Sydney',
              __typename: 'JobLocation',
            },
            salaryText: '',
            solMetadata: {
              token: '1~2d1f2aa5-aabb-40bf-8e33-b3136c1c7384',
              jobId: '41356665',
              tags: {
                'recs:type': 'recommendedJobs',
                'recs:version': '1.0.0',
                'recs:product': 'unknown',
                'recs:experimentGroup': 'none-A',
              },
            },
            status: 'Active',
            subclassification: 'Sales Representatives/Consultants',
            title: 'Sales & Marketing - Portable | Flexible Opportunity ',
            __typename: 'RecommendedJob',
          },
        ],
        __typename: 'RecommendedJobs',
      },
      __typename: 'Recommendations',
    },
    __typename: 'Candidate',
  },
};

export default getRecommendations;
